import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import Notification from 'components/Notification';
import PreLoaderWidget from 'components/Loader';

import Routes from 'routes';
import store from 'store';


const Root = () => (
    <Provider store={store}>
        <BrowserRouter basename="/">
             <Notification/>
            <PreLoaderWidget/>
            <Routes/>
        </BrowserRouter>
    </Provider>
);

export default Root;
